// src/js/app.ts
import { Rive } from '@rive-app/canvas';

console.log('Aeizon.io – Rive harness starting...');

const canvas = document.getElementById('rive-canvas') as HTMLCanvasElement;

if (!canvas) {
  console.error('Rive canvas element not found');
} else {
  const riveInstance = new Rive({
    canvas: canvas,
    src: '/assets/aeizon.riv',        // ← will 404 until we add the file
    autoplay: true,
    fit: 'cover',                     // Rive handles scaling internally
    alignment: 'center',

    onLoad: () => {
      console.log('✅ Rive file loaded successfully – full viewport ready');
      // This is the correct way to sync drawing surface
      riveInstance.resizeDrawingSurfaceToCanvas();
    },

    onError: (err) => {
      console.error('Rive load error (expected until .riv file exists):', err);
    }
  });

  // Resize handler for orientation / window changes
  const handleResize = () => {
    if (riveInstance) {
      riveInstance.resizeDrawingSurfaceToCanvas();
    }
  };

  window.addEventListener('resize', handleResize);
}
